import React from "react";

const Page = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
  };

  return (
    <div className="w-full h-full text-white" style={styles.blackbg}>
      <div className="w-full max-w-2xl m-auto py-8 px-4">
        <div className="text-xl" style={styles.blueText}>
          AIESEC in SLIIT
        </div>
        <div className="text-4xl font-bold">ILT - Importance of Language Teaching</div>
        <div className="text-xl mt-1 text-gray-400">OC Application Package</div>

        <div className="mt-8">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Event Introduction</div>
          <p className="text-gray-400">
            Importance of Language Teaching (ILT) is a functional event organized by AIESEC in SLIIT. This event is a kind of seminar process for the educational institutes to
            create an awareness of Language Teaching and explaining how AIESEC can provide potential opportunities to them. This event will be happening in August.
          </p>
        </div>

        <div className="mt-8">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Timeline</div>
          <div>
            <span className="font-bold">Application Open - </span> <span className="text-gray-300">7th July</span> <br />
            <span className="font-bold">OCP Application Deadline - </span> <span className="text-gray-300">9th July</span> <br />
            <span className="font-bold">OCVP Application Deadline - </span> <span className="text-gray-300">12th July</span> <br />
          </div>
        </div>

        <div className="mt-8">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Team Structure</div>
          <div>
            <span className="font-bold">OCP</span> <span className="text-gray-400">x1</span> <br />
            <span className="font-bold">OCVP Public Relations</span> <span className="text-gray-400">x3</span> <br />
            <span className="font-bold">OCVP Marketing</span> <span className="text-gray-400">x2</span> <br />
            <span className="font-bold">OCVP External Relations</span> <span className="text-gray-400">x3 </span> <br />
            <span className="font-bold">OCVP Logistics</span> <span className="text-gray-400">x1</span> <br />
            <span className="font-bold">OCVP Finance</span> <span className="text-gray-400">x1</span> <br />
          </div>
        </div>

        <div className="mt-8">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Available Roles</div>
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #FFC845" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#FFC845" }}>
              OCP <span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Lead the OC financially and potentially to succeed in the event</li>
                <li>Focus point on functional sales.</li>
                <li>Ensure the event meets its goals agreed upon between the OC and the EB of AIESEC in SLIIT.</li>
                <li>Ensure proper communication and reporting with OC and EB</li>
                <li>Setting out initial Organizing timelines for all the OCVPs.</li>
                <li>Setting out an ER plan with the PD Team.</li>
                <li>Setting out a PR plan with OEVPs.</li>
                <li>Accountable for the responsibilities which are assigned.</li>
                <li>Plan OC tasks and Evaluate OCVP performances.</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in Managing people.</li>
                <li>Experience in Partnership Development</li>
                <li>Experience in Functional Goal Achievements.</li>
                <li>Experience in event management and coordination</li>
                <li>Risk Management</li>
                <li>Being Accountable</li>
                <li>Time Management</li>
                <li>Leadership Development</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #0373f3" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#0373f3" }}>
              OCVP Public Relations <span className="text-gray-500"> x3</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Managing Functional Sales</li>
                <li>Being the touchpoint of Language Teaching Centers, IR Partner, Educational Institutes and AIESEC in SLIIT</li>
                <li>Setting the potential partnerships with the Educational institutes.</li>
                <li>Answering all the inquiries from the participants</li>
                <li>Managing registrations, database, and invitations of participants</li>
                <li>Managing the synergy with ER, Marketing, and Logistics</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in event management coordination.</li>
                <li>Experience in Professional negotiating with multi-region people</li>
                <li>Experience in Functional sales.</li>
              </ul>
            </div>
          </div>
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #F85A40" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#F85A40" }}>
              OCVP Marketing <span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Managing Promotions material making</li>
                <li>Managing Social media platforms.</li>
                <li>Coordinate the event platform</li>
                <li>Managing the synergy with ER and PR team for sales</li>
                <li>Working promptly</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in partnership management with variety of Stakeholders</li>
                <li>Experience in planning and running marketing campaigns</li>
                <li>Experience in designing promotional material and platforms for an event</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #FFC845" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#FFC845" }}>
              OCVP External Relations <span className="text-gray-500"> x3</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Conducting market research</li>
                <li>Working on potential partners with the PD team. </li>
                <li>Approach potential companies for partner-ups.</li>
                <li>Follow-ups and managing value deliveries of Partners.</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in Market research</li>
                <li>Experience in Partnership Development.</li>
                <li>Experience in Event management</li>
                <li>Experience in Professional negotiating with Corporate.</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #0CB9C1" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#0CB9C1" }}>
              OCVP Finance<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Preparing event budget</li>
                <li>Preparing the event report</li>
                <li>Managing the proper documentation process</li>
                <li>Expenditure tracking</li>
                <li>Ensure partner value deliveries</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in Finance</li>
                <li>Experience in Revenue management</li>
                <li>Experience in Event Coordination</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #0373f3" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#0373f3" }}>
              OCVP Logistics<span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Coordinate with Platform to facilitate the event</li>
                <li>Estimate the providing learning and delivery materials.</li>
                <li>Managing the synergy with ER and Marketing team for sales</li>
                <li>Managing proper In-kind/ Gift and Social media partners</li>
              </ul>
            </div>{" "}
            <br />
            <div className="font-bold">Experience</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Experience in Partnership Development</li>
                <li>Experience in Event Coordination</li>
                <li>Experience in Professional negotiating</li>
              </ul>
            </div>
          </div>
          {/** Contact Info ***/}
          <div className="mt-8">
            <div className="w-full h-1 bg-gray-700 mb-8"></div>
            <div className="text-2xl mb-4 font-semibold">Contact Info</div>
            <div>
              <div>For any clarifications, </div>
              <div style={styles.blueText} className="text-3xl">
                Thanushan Selvarasa
              </div>
              <div className="text-gray-400">OEVP iGT B2B – AIESEC in SLIIT</div>
              <div className="text-gray-400">thanushan.selvarasa@aiesec.net</div>
              <div className="text-gray-400">+94 76 917 5451</div>
            </div>
          </div>
          <a href="https://forms.gle/Bz5HqAzTditoJGn19 " target="_blank" rel="noreferrer">
            <div className="mt-8 rounded-md w-full h-10 text-black text-center text-lg font-bold grid content-center cursor-pointer" style={{ background: "#FFC845" }}>
              Apply for OCP
            </div>
          </a>
          <a href="https://forms.gle/74QgakfQpvt8r623A " target="_blank" rel="noreferrer">
            <div className="mt-2 mb-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer" style={{ background: "#037ef3" }}>
              Apply for OCVP
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Page;
